import React from "react"
import posed, { PoseGroup} from 'react-pose'
import styled from 'styled-components'
import { Link } from "gatsby"
import { IconContext } from "react-icons";
import { FiTwitter, FiFacebook, FiLinkedin, FiGithub  } from "react-icons/fi";

const UlPose = posed.ul({
  open: {
    delayChildren: 1000,
    staggerChildren: 100,
  },
  closed: {
    staggerChildren: 100,
  }
});

const Ul = styled(UlPose)`
  list-style-type: square;
  color: white;
  margin-left: 0;
  li {
    list-style: none outside none;
    width: min-content;
    display: inline-block;
    :last-child {
     margin-bottom: 0;
     padding-right: 0;
    }
    @media (min-width: 1024px) {
      display: list-item;
    }
  }
  a {
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
  svg {
    height: 20px;
    @media (min-width: 1024px) {
      height: 24px;
    }
  }
  @media (min-width: 1024px) {
    margin-left: 2rem;
  }
`

const Li = posed.li({
  open: {
    x: 0,
    opacity: 1
  },
  closed: {
    x: -20,
    opacity: 0
  },
  hoverable: true,
  init: { scale: 1 },
  hover: { scale: 1.2 }
});

class Social extends React.Component {
  state = { isVisible: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }, 2500);
  }

  render() {
    const { isOpen, className } = this.props;

    return(
      <IconContext.Provider key="scroll" value={{ color: "white", className: "social-menu-icon", size: "1.5em" }}>
        <Ul className={className} pose={isOpen ? 'open' : 'closed'}>
          <Li className="pr-2 mb-0 lg:mb-3">
            <a href="#" target="_blank" title="Soulweb Solutions Twitter" rel="noreferrer">
              <FiTwitter/>
            </a>
          </Li>
          <Li className="pr-2 mb-0 lg:mb-3">
            <a href="https://www.facebook.com/soulwebsolutions/" target="_blank" title="Soulweb Solutions Facebook" rel="noreferrer">
              <FiFacebook/>
            </a>
          </Li>
          <Li className="pr-2 mb-0 lg:mb-3">
            <a href="https://www.linkedin.com/company/soulweb-solutions-limited/" target="_blank" title="Soulweb Solutions Linkedin" rel="noreferrer">
              <FiLinkedin/>
            </a>
          </Li>
          <Li className="pr-2 mb-0 lg:mb-3">
            <a href="#" target="_blank" title="Soulweb Solutions Github" rel="noreferrer">
              <FiGithub/>
            </a>
          </Li>
        </Ul>
      </IconContext.Provider>
    )
  }
}

export default Social;
